import { render, staticRenderFns } from "./GroupSelectClinicsInput.vue?vue&type=template&id=1625a39a"
import script from "./GroupSelectClinicsInput.vue?vue&type=script&lang=js"
export * from "./GroupSelectClinicsInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports